import http from '../../utils/fetch';


export default {

    baseurl:'/api/swyl/v1/demo/bscCgGscodePrice',

    selecPage(query) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    shenPiAgentPass(data) {
        return http({
            url: this.baseurl+'/shenPiAgentPass',
            method: 'post',
            data
        });
    },
    selectById(id) {
        return http({
            url: this.baseurl+'/selectById?id=' + id,
            method: 'post',
        });
    },
    insert(query) {
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: query
        });
    },
    multipleItems(data) {
        return http({
            url: this.baseurl+'/multipleItems',
            method: 'post',
            data
        });
    },
    deleteById(query) {
        return http({
            url: this.baseurl+'/deleteById?id=' + query,
            method: 'post',
        });
    },
    updateById(query) {
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params: query
        });
    },
    downloadExcel(query) {
        return http({
            url: this.baseurl+'/downloadExcel',
            method: 'post',
            params: query
        });
    },



}